import PropTypes from 'prop-types'

export default function ArrowPrevious({ className = '' }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M12.8333 6.99996H1.16663M1.16663 6.99996L6.99996 12.8333M1.16663 6.99996L6.99996 1.16663"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

ArrowPrevious.propTypes = {
  className: PropTypes.string,
}
